import { getBrowserAgent } from "@/config/newrelic";

export function forwardWarn(message: string, customAttributes?: object) {
  getBrowserAgent()?.log(message, { level: "WARN", customAttributes });
}

export function forwardError(error: Error, customAttributes?: object) {
  getBrowserAgent()?.noticeError(error, customAttributes);
}
